export const TRAIN_COLORS = {
  Red: '#c60c30',
  Blue: '#00a1de',
  Brn: '#62361b',
  G: '#009b3a',
  Org: '#f9461c',
  P: '#522398',
  Pink: '#e27ea6',
  Y: '#f9e300'
}

// Yellow/Pink chips need dark text to stay legible
export const chipTextColor = (routeCode) =>
  routeCode === 'Y' || routeCode === 'Pink' ? '#111' : '#fff'

export const formatMinutes = ({ minutes, approaching }) =>
  approaching || minutes <= 0 ? 'Due' : `${minutes} min`

export const formatDistance = (meters) => {
  const feet = meters * 3.28084
  if (feet < 1000) return `${Math.max(Math.round(feet / 50) * 50, 50)} ft`
  return `${(meters / 1609.344).toFixed(1)} mi`
}

// Number config fields arrive as strings from the modal draft
export const positiveNumber = (value, fallback) => {
  const n = Number(value)
  return Number.isFinite(n) && n > 0 ? n : fallback
}
